import script from "./CarouselManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarouselManage.vue?vue&type=script&lang=ts&setup=true"

import "./CarouselManage.vue?vue&type=style&index=0&id=d187d42c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d187d42c"]])

export default __exports__